import { assets } from '../assets'

import {
  Object3D,
  Box3,
  TextureLoader,
  FrontSide
} from 'three'

export class Station extends Object3D {
  constructor () {
    super({name: 'Station'})

    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
    this.promises = []

    // this.box = new Box3().makeEmpty()
    this._opacity = 1
    this.scale.set(5, 5, 5)
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })

    this.loaders().then(this.resolve)
  }

  loaders () {
    return Promise.all([
      // new Promise( (resolve, reject) => {
      //   new BufferGeometryLoader().load('/models/capsuleGeometry.json', geometry => {
      //     this.capsuleGeometry = geometry
      //     resolve()
      //   })
      // }),
      new Promise( (resolve, reject) => {
        assets.station.require( (environment) => {
          environment.scene.traverse( (child) => {
            if (!child.isMesh) return
            child.receiveShadow = false
            child.castShadow = true
            child.material.side = FrontSide
            child.material.shadowSide = FrontSide
            child.material.needsUpdate = true
            // child.material = new MeshMatcapMaterial({
            //   matcap,
            //   color: 0xffffff
            // })
          })

          this.add(...environment.scene.children)
          resolve()
        })
      })
    ])
  }

  get opacity () {
    return this._opacity
  }

  set opacity (opacity) {
    this._opacity = opacity
    this.traverse((child) => {
      child.isMesh && child.material.color.setRGB(opacity, opacity, opacity)
    })
  }

  animate () {
    gsap.to(this, 2, {
      opacity: 1,
      ease: 'easeOutQuad'
    })
  }
}
